/* src/components/product/RecommendedProducts.tsx */

"use client";

import Image from "next/image";
import Link from "next/link";
import { useState, useEffect, useCallback } from "react";
import { RefreshCw } from "lucide-react";

type ProductPreview = {
	id: string;
	name: string;
	imageUrl: string;
};

type RecommendedProductsProps = {
	productPool: ProductPreview[];
	title: string;
	buttonText: string;
};

const RECOMMENDATION_COUNT = 4;

export function RecommendedProducts({
	productPool,
	title,
	buttonText,
}: RecommendedProductsProps) {
	const [recommendations, setRecommendations] = useState<ProductPreview[]>([]);

	const shuffleAndPick = useCallback(() => {
		const shuffled = [...productPool].sort(() => 0.5 - Math.random());
		setRecommendations(shuffled.slice(0, RECOMMENDATION_COUNT));
	}, [productPool]);

	useEffect(() => {
		shuffleAndPick();
	}, [shuffleAndPick]);

	if (productPool.length === 0) {
		return null;
	}

	return (
		<div className="mt-16 md:mt-20">
			<div className="flex justify-between items-center mb-6">
				<h2 className="text-2xl font-bold text-gray-800">{title}</h2>
				{productPool.length > RECOMMENDATION_COUNT && (
					<button
						onClick={shuffleAndPick}
						className="flex items-center px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
					>
						<RefreshCw className="w-4 h-4 mr-2" />
						{buttonText}
					</button>
				)}
			</div>
			<div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
				{recommendations.map((product) => (
					<Link
						key={product.id}
						href={`/product/item/${encodeURIComponent(product.id)}`}
						className="group block border border-gray-200 rounded-lg overflow-hidden shadow-sm transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
					>
						<div className="relative w-full aspect-square bg-gray-100">
							{/* --- 修正开始 --- */}
							<Image
								src={product.imageUrl}
								alt={product.name}
								fill
								style={{ objectFit: "cover" }}
								sizes="(max-width: 768px) 50vw, 25vw"
								className="transition-transform duration-300 group-hover:scale-105"
							/>
							{/* --- 修正结束 --- */}
						</div>
						<div className="p-3 bg-white text-center">
							<h3 className="text-sm font-semibold text-gray-800 truncate">
								{product.name}
							</h3>
						</div>
					</Link>
				))}
			</div>
		</div>
	);
}
